import { render, staticRenderFns } from "./EditColiseum.vue?vue&type=template&id=fd61762a"
import script from "./EditColiseum.vue?vue&type=script&lang=js"
export * from "./EditColiseum.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports